module.exports = __webpack_public_path__ + "img/logo.51cd3a9c.png";